// src/components/Header.js
import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { NavLink } from "./NavLink";
import { useState, useEffect } from "react";


const Header = ({ headerRef }) => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sectionIds = [
      "home",
      "achievements",
      "publications",
      "contributions",
      "sponsorships",
      "about",
      "join"
    ];

    const handleScroll = () => {
      let current = "home";
      let minDistance = Infinity;

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          const distance = Math.abs(rect.top - 80);
          if (rect.top <= 80 && distance < minDistance) {
            minDistance = distance;
            current = id;
          }
        }
      }
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top" collapseOnSelect ref={headerRef}>
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ fontFamily: "museo", fontWeight: 900, color: "#E61E2A", letterSpacing: "2.5px", fontSize: "1.65rem", padding: "5px 0" }}>
          REDBACKBOTS
          {/* <img
            alt="RMIT Redbackbots Logo"
            src="/images/RedbacksLogo.png" // Adjust the path based on your folder structure
            width="128"
            height="51"
            className="d-inline-block align-top"
          /> */}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="ml-auto">
            <NavLink shortUrl={"home"} displayText={"Home"} activeSection={activeSection} />
            <NavLink shortUrl={"achievements"} displayText={"Achievements"} activeSection={activeSection} />
            <NavLink shortUrl={"publications"} displayText={"Publications"} activeSection={activeSection} />
            <NavLink shortUrl={"contributions"} displayText={"Contributions"} activeSection={activeSection} />
            <NavLink shortUrl={"sponsorships"} displayText={"Sponsorships"} activeSection={activeSection} />
            <NavLink shortUrl={"about"} displayText={"The Team"} activeSection={activeSection} />
            <NavLink shortUrl={"join"} displayText={"Join the Team"} activeSection={activeSection} />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
